import { post } from './client';

/**
 * 
 * 
 * @returns 
 */
export function getCourseDeliveryOptions(data) {
    return post('deliveryoptions', data)
}

/**
 * 
 * 
 * @returns 
 */
export function getDeliveryOptionsForPrice(data) {
    return post('deliveryoptions/list', data)
}
